// src/app/layout/Sidebar.tsx
import { NavList } from './NavList';
import { SidebarUserSection } from './SidebarUserSection';

// Desktop-only nav surface (>= lg). Item rendering lives in NavList and
// the user/logout block lives in SidebarUserSection — both shared with
// MobileNavDrawer below lg. This component's own desktop markup/classes
// are unchanged from before.

export function Sidebar({ profileLayout = false }: { profileLayout?: boolean }) {
  return (
    <aside className={`hidden lg:flex lg:w-60 lg:shrink-0 lg:flex-col border-e border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]${profileLayout ? ' representative-profile-sidebar' : ''}`}>
      {/* Brand area */}
      <div className="flex items-center gap-2.5 border-b border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-4 py-4">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[var(--vania-accent-violet,#7c6cff)] text-sm font-bold text-white">
          V
        </span>
        <span className="min-w-0 truncate text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          VaniaLabs
        </span>
      </div>

      <NavList />

      <SidebarUserSection />
    </aside>
  );
}
